import applyMiddleware from '../../utils/route/applyMiddleware';
import requireRole from '../../utils/route/requireRole';
import Roles from '../../constants/Roles';

const userManagement = {
  name: 'user-management',
  path: 'user-management',
  onEnter: applyMiddleware(requireRole(Roles.USER_MANAGER)),
  async getComponent() {
    const { UserManagementMain } = await import('./UserManagementRoutes');

    return UserManagementMain;
  },

  async getChildRoutes() {
    const { UserManagementRoutes } = await import('./UserManagementRoutes');

    return UserManagementRoutes;
  }
};

export default userManagement;



// WEBPACK FOOTER //
// ./src/apps/UserManagement/index.js